// Package imports:
import React from 'react';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';

export type AvatarNames = 'NASDAQ' | 'ARION' | 'ISB' | 'KVIKA' | 'KVIKAE' | 'MAREL' | 'EIM' | 'EIK' | 'FESTI' | 'HAGA' | 'ICESEA' | 'NOVA' | 'OLGERD' | 'ORIGO' | 'REITIR'
 | 'SIMINN' | 'SJOVA' | 'VIS' | 'SKEL' | 'REGINN' | 'SVN' | 'SYN' | 'AKTA' | 'IV' | 'IS' | 'STEFNIR' | 'LANDSBREF' | 'GAMMA' | 'FRJALSI'
 | 'LAIS' | 'ICEAIR' | 'OMX' | 'HAMP' | 'KALD' | 'KLAPP B' | 'PLAY' | 'SFS B' | 'SOLID' | 'OSSR' | 'AMRQ';

type AvatarSizes = 'sm' | 'md' | 'lg';

interface IProps {
    name?: AvatarNames,
    size: AvatarSizes,
    color?: boolean,
    backgroundGrey?: boolean,
    noPadding?: boolean,
    dropShadow?: boolean,
    dataLink?: string
};

const Avatar: React.FC<IProps> = ({
    name,
    size,
    color,
    backgroundGrey,
    noPadding,
    dataLink
}) => {
    return (
        <div className={cx(
            'KCL_avatar',
            size,
            {'grey': backgroundGrey},
            {'with-padding': !noPadding},
            name
        )}>
            {(dataLink)
                ? (<object style={{maxWidth: '90%'}}  type="image/png" name={uuidv4()} data={dataLink}> </object>)
                : (color)
                ? <img
                    src={`https://cdn.livemarketdata.com/Avatars/${name}-color.svg`}
                    alt={name}
                    width="60"
                    height="60"
                />
                : <img
                    src={`https://cdn.livemarketdata.com/Avatars/${name}.svg`}
                    alt={name}
                    width="60"
                    height="60"
                />
            }
        </div>
    );
}
export default Avatar;